import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SecretService } from './secret.service';
import {MatDialog} from '@angular/material/dialog';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    constructor(public dialog: MatDialog, private secretService: SecretService) {}

    /**
     * Navigate to login page
     */
    public loginNavigate(): void {
        location.href = `${environment.umsLoginUrl}/login?callback=${encodeURIComponent(location.href)}&app=CP&theme=${
            this.getSettings().sAppTheme
        }`;
    }

    private getSettings(): any {
        return this.secretService.getPortalSettings() ? this.secretService.getPortalSettings() : {};
    }
}
